module.exports = __webpack_public_path__ + "img/hr-level2addon_mining_hands_mask.8ccfc0e4.png";